import React, { useState } from 'react';

import CloseIcon from '@material-ui/icons/Close';
import { createPortal } from 'react-dom';

import { Backdrop, CloseBtn, Wrapper } from './styles';

export interface Props {
  isShowing: boolean;
  hide?: () => void;
  backdropClose?: boolean;
  showCloseBtn?: boolean;
  noSpacing?: boolean;
}

const Modal: React.FC<Props> = ({
  isShowing,
  hide,
  backdropClose = true,
  showCloseBtn = false,
  noSpacing = false,
  children,
}) => {
  if (!isShowing) {
    return null;
  }

  const [animateOut, setAnimateOut] = useState(false);

  const handleClose = () => {
    setAnimateOut(true);

    setTimeout(() => {
      setAnimateOut(false);
      hide && hide();
    }, 200);
  };

  return createPortal(
    <Wrapper animateOut={animateOut} noSpacing={noSpacing}>
      <Backdrop onClick={backdropClose ? handleClose : undefined} />
      {showCloseBtn && (
        <CloseBtn type="button" onClick={handleClose}>
          <CloseIcon htmlColor={'white'} />
        </CloseBtn>
      )}
      {children}
    </Wrapper>,
    document.body,
  );
};

export default Modal;
